module.exports = __webpack_public_path__ + "static/media/phone-without-intercom.d13da759.svg";